import React from "react";

import { baseURL as employeeBaseUrl } from "Dashboard/EmployeeUrls";
import { adminURL as adminUrl, switchCompanyURL as switchCompanyUrl, baseURL as employerBaseUrl } from "Dashboard/EmployerUrls";
import { companyTokenString } from "Utils/companyToken";
import { baseUrl, userSettingsURL as userSettingsUrl, supportUrl } from "ZeroRuby/urls";

import { NavBarDropdown, NavBarMenuItem } from "Cobalt/NavBar";
import Icon from "Common/Icon";
import { appendAuthParams } from "Common/TokenAuth/Utils";

type Props = {
  menuTitle?: string;
  showAdminLink?: boolean;
  showSwitchEmployerDashboard?: boolean;
  showSwitchEmployeeDashboard?: boolean;
  showSwitchCompany?: boolean;
  showUserSettings?: boolean;
  showLogout?: boolean;
  showSupport?: boolean;
};

const AccountMenuTitle = ({ title }: { title?: string }) => (
  <span>
    <Icon icon="user" flavor="solid" spacing="right" />
    <span>{title || "Account"}</span>
  </span>
);

const TopBarAccountLinksDumb = ({
  menuTitle,
  showAdminLink,
  showSwitchEmployerDashboard,
  showSwitchEmployeeDashboard,
  showSwitchCompany,
  showUserSettings,
  showLogout,
  showSupport = true,
}: Props) => (
  <>
    {showSupport && (
      <NavBarMenuItem key="supportLink" href={supportUrl}>
        Support
      </NavBarMenuItem>
    )}
    <NavBarDropdown label={<AccountMenuTitle title={menuTitle} />}>
      {showAdminLink && (
        <NavBarMenuItem key="adminLink" href={adminUrl}>
          Admin
        </NavBarMenuItem>
      )}
      {showSwitchEmployerDashboard && (
        <NavBarMenuItem key="employerDashboardLink" href={appendAuthParams(`${baseUrl}${companyTokenString()}${employerBaseUrl}`)}>
          Switch to Company Dashboard
        </NavBarMenuItem>
      )}
      {showSwitchEmployeeDashboard && (
        <NavBarMenuItem key="employeeDashboardLink" href={appendAuthParams(`${baseUrl}${employeeBaseUrl}`)}>
          Switch to Employee Dashboard
        </NavBarMenuItem>
      )}
      {showSwitchCompany && (
        <NavBarMenuItem key="switchCompanyLink" href={appendAuthParams(`${baseUrl}${switchCompanyUrl}`)}>
          Switch Company
        </NavBarMenuItem>
      )}
      {showUserSettings && (
        <NavBarMenuItem key="userSettingsLink" href={appendAuthParams(`${baseUrl}${userSettingsUrl}`)}>
          User Settings
        </NavBarMenuItem>
      )}
      {showLogout && (
        <NavBarMenuItem key="logoutLink" href="/logout">
          Sign out
        </NavBarMenuItem>
      )}
    </NavBarDropdown>
  </>
);

export default TopBarAccountLinksDumb;
